// Bandeja de avisos de la persona: asignaciones, entregas, cambios, vencimientos.
import { Link } from "@tanstack/react-router";
import { Boton, EsqueletoTabla, Pill, PuntoNaranja, TituloPagina, Vacio, useToast } from "@iavmx/ui";
import { useMutation } from "@tanstack/react-query";
import { leer } from "../api";
import { useSesion } from "../sesion";
import { useAvisos, useRefrescar } from "./datos";
import { ErrorCarga } from "./comunes";
import { fechaHora } from "./formato";

/** Si el aviso apunta a un ticket de esta app, se navega dentro del SPA. */
function ticketDe(url: string | null): string | null {
  if (!url) return null;
  try {
    const m = /^\/tickets\/([0-9a-f-]{36})$/i.exec(new URL(url, window.location.origin).pathname);
    return m?.[1] ?? null;
  } catch {
    return null;
  }
}

export function Avisos() {
  const { api } = useSesion();
  const q = useAvisos();
  const refrescar = useRefrescar();
  const { avisar } = useToast();
  const leida = useMutation({
    mutationFn: (id: string) => api.api.tickets.avisos[":id"].leida.$post({ param: { id } }).then((r) => leer(r)),
    onSuccess: refrescar,
    onError: (e) => avisar({ titulo: "No se pudo marcar", descripcion: e.message, tono: "error" }),
  });
  const avisos = q.data?.avisos ?? [];
  const sinLeer = avisos.filter((a) => !a.leidaEn).length;
  return (
    <>
      <TituloPagina descripcion={q.data ? `${sinLeer} sin leer. Los mismos avisos llegan por correo cuando hay Resend configurado.` : "Cargando…"}>
        Avisos
        <PuntoNaranja />
      </TituloPagina>
      {q.isLoading ? (
        <EsqueletoTabla columnas={2} />
      ) : q.error ? (
        <ErrorCarga error={q.error} />
      ) : avisos.length === 0 ? (
        <Vacio titulo="Sin avisos" texto="Cuando te asignen un ticket, entreguen algo tuyo o venza un plazo, aparece aquí." />
      ) : (
        <ul className="divide-y divide-linea border-y border-linea">
          {avisos.map((a) => {
            const ticketId = ticketDe(a.url);
            return (
              <li key={a.id} className="flex flex-col gap-2 py-3 md:flex-row md:items-start md:gap-4">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    {!a.leidaEn && <Pill tono="azul">Nuevo</Pill>}
                    <p className={`font-ui text-sm ${a.leidaEn ? "text-tinta-tenue" : "font-semibold"}`}>{a.titulo}</p>
                  </div>
                  {a.texto && <p className="mt-1 font-ui text-sm text-tinta-2">{a.texto}</p>}
                  <p className="mt-1 font-ui text-xs text-tinta-tenue">{fechaHora(a.creadoEn)}</p>
                </div>
                <div className="flex shrink-0 gap-2">
                  {ticketId ? (
                    <Boton variante="liga" tamano="sm" asChild>
                      <Link to="/tickets/$id" params={{ id: ticketId }}>
                        Abrir
                      </Link>
                    </Boton>
                  ) : a.url ? (
                    <Boton variante="liga" tamano="sm" asChild>
                      <a href={a.url}>Abrir</a>
                    </Boton>
                  ) : null}
                  {!a.leidaEn && (
                    <Boton variante="contorno" tamano="sm" onClick={() => leida.mutate(a.id)}>
                      Marcar leído
                    </Boton>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
